import { BaseSyntheticEvent } from 'react';
import { Controller } from 'react-hook-form';
import { Cell } from '@/shared/ui/Cell';
import { Select as SelectComponent } from '@salutejs/sdds-insol';

type Props = {
    className?: string;
    items: { label: string; value: string }[];
    label: string;
    name: string;
    size?: 'l' | 'm' | 's' | 'xs';
    onChange?: (value: string) => void;
};

export const Select = ({ className, size = 'l', items, onChange, label, name }: Props) => {
    return (
        <Controller
            render={({ field, fieldState }) => (
                <Cell className={className} error={fieldState.error?.message}>
                    <SelectComponent
                        name={name}
                        size={size}
                        items={items}
                        label={label}
                        value={field.value}
                        labelPlacement="inner"
                        onChange={(e: BaseSyntheticEvent) => {
                            field.onChange(e);
                            onChange?.(String(e));
                        }}
                    />
                </Cell>
            )}
            name={name}
        />
    );
};
